// extracted by mini-css-extract-plugin
export default {"pm":"AddRemCount_pm__2o9m5","counter":"AddRemCount_counter__nSXdn"};